// A page split out of the bundle ("chunk") is fetched on demand, and a deploy replaces every
// chunk file with a new hash. A browser still holding yesterday's index.html therefore asks for
// a file that no longer exists and the lazy page throws (HAL-FRONTEND-V, "Loading chunk 8963 failed").
//
// Recovery reloads ONLY while a route change is under way (nothing half-typed on screen yet),
// at most once per 60 seconds via a sessionStorage timestamp so it can never loop. Any other
// chunk failure shows a "new version" banner and leaves the page alone.
import { toast } from 'sonner';

export const CHUNK_ERROR_RE = /Loading chunk\s+[\w-]+\s+failed|ChunkLoadError|Loading CSS chunk|Failed to fetch dynamically imported module|error loading dynamically imported module/i;

const GUARD_KEY = 'hal-chunk-reload-at';
export const RELOAD_COOLDOWN_MS = 60 * 1000;
export const NAVIGATION_WINDOW_MS = 10 * 1000;

let lastNavigationAt = Date.now();

export const markNavigation = (at = Date.now()) => { lastNavigationAt = at; };

export const isChunkLoadError = (error) => {
  if (!error) return false;
  const text = typeof error === 'string' ? error : `${error.name || ''} ${error.message || ''}`;
  return CHUNK_ERROR_RE.test(text);
};

export const showUpdateBanner = () => {
  toast('A new version is available — click to refresh', {
    id: 'app-update',
    duration: Infinity,
    action: { label: 'Refresh', onClick: () => window.location.reload() },
  });
};

const reloadAllowed = (now) => {
  try {
    const last = Number(sessionStorage.getItem(GUARD_KEY) || 0);
    if (now - last < RELOAD_COOLDOWN_MS) return false;
    sessionStorage.setItem(GUARD_KEY, String(now));
  } catch (_) { /* private mode — one reload is still better than a white screen */ }
  return true;
};

// Returns true if a reload was started, so a caller can keep showing its own message otherwise.
export const recoverFromChunkError = (error) => {
  if (!isChunkLoadError(error)) return false;
  const now = Date.now();
  if (now - lastNavigationAt <= NAVIGATION_WINDOW_MS && reloadAllowed(now)) {
    window.location.reload();
    return true;
  }
  showUpdateBanner();
  return false;
};
